import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.invite_member || initialState;

export const selectInviteMember = createSelector([selectSlice], state => state);
